export enum EDocumentType {
  TAX_AUTHORITIES_PAYMENT_CERTIFICATE = 'TAX_AUTHORITIES_PAYMENT_CERTIFICATE',
  TAX_AUTHORITIES_PAYMENT_CERTIFICATE_OKCARGO = 'TAX_AUTHORITIES_PAYMENT_CERTIFICATE_OKCARGO',
  SOCIAL_SECURITY_PAYMENT_CERTIFICATE = 'SOCIAL_SECURITY_PAYMENT_CERTIFICATE',
  BANK_OWNERSHIP_CERTIFICATE = 'BANK_OWNERSHIP_CERTIFICATE',
  GOODS_ASSURANCE = 'GOODS_INSURANCE',
  EUROPEAN_LICENSE = 'EUROPEAN_LICENSE',
  CIVIL_RESPONSABILITY_ASSURANCE = 'RLC',
  ACTIVITY_LICENSE = 'ACTIVITY_LICENSE',
  DELIVERY_NOTE = 'DELIVERY_NOTE',
  FREIGHT_EXPORT = 'FREIGHT_EXPORT',
  EMISSION_JOURNEY = 'EMISSION_JOURNEY',
  DELIVERY_NOTES_EXPORT = 'DELIVERY_NOTES_EXPORT',
  INVOICING_REPORT = 'INVOICING_REPORT',
  FREIGHTS_WITH_ISSUES_REPORT = 'FREIGHTS_WITH_ISSUES_REPORT',
  APAAC_ASSIGNATION_REPORT = 'APAAC_ASSIGNATION_REPORT',
  PAST_DUE_DEBT_INVOICES_REPORT = 'PAST_DUE_DEBT_INVOICES_REPORT',
  NONE = 'NONE',
}
